<app-page-header title="OTA Performance Report" subtitle="Analyze OTA request metrics and performance statistics"></app-page-header>

<div class="ota-report-container">
    <!-- Overview Cards -->
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        <p-card styleClass="metric-card">
            <div class="metric-content">
                <span class="metric-label">Price Requests</span>
                <span class="metric-value">{{ otaPerformanceData()?.totalPriceRequests ?? 0 }}</span>
            </div>
        </p-card>
        <p-card styleClass="metric-card">
            <div class="metric-content">
                <span class="metric-label">Book Requests</span>
                <span class="metric-value">{{ otaPerformanceData()?.totalBookRequests ?? 0 }}</span>
            </div>
        </p-card>
        <p-card styleClass="metric-card">
            <div class="metric-content">
                <span class="metric-label">Search Requests</span>
                <span class="metric-value">{{
                    (otaPerformanceData()?.totalLowFareRequests || 0) + (otaPerformanceData()?.totalLowFareV2Requests || 0)
                }}</span>
            </div>
        </p-card>
        <p-card styleClass="metric-card">
            <div class="metric-content">
                <span class="metric-label">Total Pax</span>
                <span class="metric-value">{{ otaPerformanceData()?.totalPax ?? 0 }}</span>
            </div>
        </p-card>
        <p-card styleClass="metric-card">
            <div class="metric-content">
                <span class="metric-label">Look2Book Ratio</span>
                <span class="metric-value">{{ otaPerformanceData()?.look2BookRatio ?? 0 }}</span>
            </div>
        </p-card>
        <p-card styleClass="metric-card">
            <div class="metric-content">
                <span class="metric-label">Price2Book Ratio</span>
                <span class="metric-value">{{ otaPerformanceData()?.price2BookRatio ?? 0 }}</span>
            </div>
        </p-card>
    </div>

    <!-- Charts Grid -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <!-- Price Request Chart -->
        <p-card header="OTA Price Request Counts" styleClass="chart-card">
            <p-chart type="bar" height="350px" [data]="priceRequestChartData()" [options]="priceRequestChartOptions"></p-chart>
        </p-card>

        <!-- Book Request Chart -->
        <p-card header="OTA Book Request Counts" styleClass="chart-card">
            <p-chart type="bar" height="350px" [data]="bookRequestChartData()" [options]="bookRequestChartOptions"></p-chart>
        </p-card>

        <!-- Low Fare Request Chart -->
        <p-card header="OTA Low Fare Request Counts" styleClass="chart-card">
            <p-chart type="bar" height="350px" [data]="lowFareRequestChartData()" [options]="lowFareRequestChartOptions"></p-chart>
        </p-card>

        <!-- Low Fare V2 Request Chart -->
        <p-card header="OTA Low Fare V2 Request Counts" styleClass="chart-card">
            <p-chart type="bar" height="350px" [data]="lowFareV2RequestChartData()" [options]="lowFareV2RequestChartOptions"></p-chart>
        </p-card>
    </div>
</div>
